import { Outlet, useLocation } from "react-router-dom";
import { useApp } from "../context/AppContext";
import OnboardingWizard from "./OnboardingWizard";
import DesktopAccessQr from "./DesktopAccessQr";

export default function MobileFrame() {
  const { user, setupCompleted } = useApp();
  const location = useLocation();
  const showWizard =
    !!user && !setupCompleted && location.pathname !== "/login";

  return (
    <div
      className="min-h-screen w-full bg-zinc-100 dark:bg-black bg-grid flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-12 sm:p-6"
      data-testid="mobile-frame-root"
    >
      <DesktopAccessQr />
      <div
        className="relative w-full max-w-[430px] min-h-screen sm:min-h-[860px] sm:h-[860px] sm:my-0 bg-white dark:bg-zinc-950 sm:rounded-[36px] sm:border-[10px] sm:border-zinc-300 dark:sm:border-zinc-900 sm:shadow-[0_25px_60px_-15px_rgba(0,0,0,0.25)] dark:sm:shadow-[0_0_60px_rgba(249,115,22,0.15),inset_0_0_0_1px_rgba(255,255,255,0.04)] sm:ring-1 sm:ring-zinc-200/60 dark:sm:ring-white/5 overflow-hidden flex flex-col shrink-0"
        data-testid="mobile-frame-device"
      >
        <div className="hidden sm:flex absolute top-0 left-1/2 -translate-x-1/2 z-50 w-32 h-6 bg-zinc-300 dark:bg-zinc-900 rounded-b-2xl items-center justify-center">
          <div className="w-2 h-2 rounded-full bg-orange-500/70" />
        </div>
        <Outlet />
        {showWizard && <OnboardingWizard />}
      </div>
      <div className="hidden sm:block fixed bottom-4 right-6 text-[10px] tracking-widest font-mono-tech text-zinc-500 dark:text-zinc-600 uppercase">
        warranty.terminal · v1.0
      </div>
    </div>
  );
}
